<template>
  <div class='review-table'>
    <v-data-table
      :headers='reviewHeaders'
      :items='reviewItems'
      hide-default-footer
      hide-default-header
      disable-sort
    >
      <template v-slot:header='{props}'>
        <tr>
          <th v-for='header in props.headers' :key='header.value' class='review-header'>
            <span v-if='!solverData || solverData.length <= 1'>{{header.text}}</span>
            <router-link v-else-if='!isNaN(headerMatches(header))' :to='headerLink(headerMatches(header))'>{{header.text}}</router-link>
            <span v-else>{{header.text}}</span>
          </th>
        </tr>
      </template>
      <template v-slot:item='{item, headers}'>
        <tr>
          <td v-for='header in headers' :key='header.value'>
            <span v-if="item.num === 'Video Link' && header.value.startsWith('time') && item[header.value]"><a :href='item[header.value]' target='_blank'>{{item[header.value]}}</a></span>
            <v-tooltip top v-else-if="(item.num === 'Open Time' || item.num === 'Submit Time') && header.value.startsWith('time')">
              <template v-slot:activator='{on}'><span v-on='on'>{{formatTime(item[header.value])}}</span></template>
              <span>UTC: {{item[header.value]}}</span>
            </v-tooltip>            
            <v-tooltip v-else-if="header.value == 'scramble' && !isNaN(item.num)" bottom>
              <template v-slot:activator='{on}'><span v-on='on'>{{item.scramble}}</span></template>
              <single-scramble :scramble='item.scramble' :type='item.type' />
            </v-tooltip>
            <span v-else>{{item[header.value]}}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <router-link v-if='$store.state.loginSettings && $store.state.loginSettings.adminAvailable' :to='{path: `/tpc/stream`, query: {solverNames: solverData.filter(Boolean).map((v) => v.solverName), solverWca: solverData.filter(Boolean).map((v) => v.wcaID)}}'>STREAM MATCHUP</router-link>
  </div>
</template>

<script>
import utils from '@/modules/utils'
import {DateTime} from 'luxon'

import SingleScramble from '@/components/TPC/Shared/SingleScramble'

export default {
  name: 'review-table',
  components: {
    SingleScramble,
  },
  props: {
    solverData: Array,
    scrambles: Array,
  },
  methods: {
    headerMatches (header) {
      const matches = header.value.match(/time(\d+)/)
      if (!matches || !matches[1]) return NaN
      return matches[1]
    },
    headerLink (i) {
      return `/tpc/results/${this.solverData[i].roundID}/${this.solverData[i].profileID}o${this.solverData[i].solverOrder}`
    },
    formatTime (iso) {
      let dt = DateTime.fromISO(iso)
      return dt.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
    }
  },
  computed: {
    reviewItems () {
      if (!this.solverData) {
        return []
      }
      const filteredSolverData = this.solverData.filter((v) => !!v)

      let solveTimes = filteredSolverData.reduce((acc, data, i) => {
        const key = `time${i}`
        const v = data.solveTimes
        if (!v) return acc
        for (let i = 0; i < v.length; i++) {
          acc[i] = {
            ...acc[i],
            [key]: utils.displayTimeWithMetadata(v[i])
          }
        }
        return acc
      }, [])

      solveTimes = solveTimes.map((v, i) => ({
        num: i + 1,
        scramble: (this.scrambles && this.scrambles[i] && this.scrambles[i].scramblestr) || '-',
        type: (this.scrambles && this.scrambles[i] && this.scrambles[i].type) || '3x3',
        ...v
      }))

      const extraData = [{num: 'Video Link', scramble: '-', ...(filteredSolverData.reduce((acc, v, i) => ({...acc, [`time${i}`]: v.videoLink}), {}))},
        {num: 'Open Time', scramble: '-', ...(filteredSolverData.reduce((acc, v, i) => ({...acc, [`time${i}`]: v.solveTimes && v.solveTimes[0] && v.solveTimes[0] .openTime}), {}))},
        {num: 'Submit Time', scramble: '-', ...(filteredSolverData.reduce((acc, v, i) => ({...acc, [`time${i}`]: v.solveTimes && v.solveTimes[0] && v.solveTimes[0].submitTime}), {}))}]

      return solveTimes.concat(
        extraData.filter((v) => {
          for (let key in v) {
            if (key.startsWith('time') && v[key] !== null && v[key] !== undefined) return true
          }
          return false
        })
      )
    },
    reviewHeaders () {
      if (!this.solverData) return [{text: '#', value: 'num', align: 'center'}, {text: 'Scramble', value: 'scramble', align: 'center'}, {text: 'Time', value: 'time', align: 'center'}]
      return [
        {text: '#', value: 'num', align: 'center'}, 
        ...(this.solverData.length === 1 ? [{text: 'Scramble', value: 'scramble', align: 'center'}] : [])]
        .concat(this.solverData.filter((v) => !!v).map((v, i) => ({text: this.solverData.length === 1 ? 'Time' : v.solverName, value: `time${i}`, align: 'center'})))
    },
    roundName () {
      return this.$store.state.eventName ? `${this.$store.state.eventName} ${utils.roundNameSuffix(this.roundID)}` : 'Round ' + this.roundID
    }
  }
}
</script>

<style scoped>
.review-table {
  display: block;
  width: 50%;
  margin: auto;
}
.review-header {
  text-align: center !important;
  font-weight: bold;
  border-bottom: thin solid rgba(0,0,0,.12);
}
</style>
